import PropTypes from 'prop-types';

import i18n from '@/i18n'

import { CardContent } from '@mui/material';
import { StyledCard, SectionTitle, ActionButton } from './DashboardStyles';

export function QuickActionsCard({ syncingWithFuga, onSubmitPitch, onExportReport, onSyncFuga }) {
  return (
    <StyledCard>
      <CardContent sx={{ padding: 0, gap: 1, '&:last-child': { paddingBottom: 0 } }}>
        <SectionTitle sx={{ marginBottom: 2, fontSize: '1.2rem' }}>
          {i18n.t('quick-actions')}
        </SectionTitle>
        <ActionButton variant="outlined" disabled onClick={onSubmitPitch}>{i18n.t('submit-new-pitch')}</ActionButton>
        <ActionButton variant="outlined" onClick={onExportReport}>{i18n.t('export-weekly-report')}</ActionButton>
        <ActionButton variant="outlined" onClick={onSyncFuga} loading={syncingWithFuga}>{i18n.t('sync-with-fuga')}</ActionButton>
      </CardContent>
    </StyledCard>
  );
}

QuickActionsCard.propTypes = {
  onSubmitPitch: PropTypes.func.isRequired,
  onExportReport: PropTypes.func.isRequired,
  onSyncFuga: PropTypes.func.isRequired,
};
